import { defaultSwatchColors } from '@/assets/js/variables';

export default {
  computed: {
    emptySwatchesClass() {
      return this.hasAnyLocalStorageSwatches
        ? {
            'empty-column-0': !this.localStorageSwatches[0],
            'empty-column-1': !this.localStorageSwatches[1],
            'empty-column-2': !this.localStorageSwatches[2],
            'empty-column-3': !this.localStorageSwatches[3],
            'empty-column-4': !this.localStorageSwatches[4],
          }
        : {};
    },
    hasAnyLocalStorageSwatches() {
      return this.localStorageSwatches?.length > 0;
    },
    pickerBind() {
      return {
        flat: true,
        showSwatches: true,
        swatches: this.swatches,
        class: this.emptySwatchesClass,
      };
    },
    swatches() {
      return defaultSwatchColors.map((colors, index) => [
        ...(this.hasAnyLocalStorageSwatches ? [this.localStorageSwatches[index] || '#FFFFFF'] : []),
        ...colors,
      ]);
    },
  },
  data: () => ({
    localStorageSwatches: [],
  }),
  methods: {
    addSwatch(value) {
      const localStorageSwatches = JSON.parse(JSON.stringify(this.localStorageSwatches || []));
      if (!localStorageSwatches.includes(value)) {
        localStorageSwatches.unshift(value);
        localStorage.setItem('color-swatches', JSON.stringify(localStorageSwatches.slice(0, 5)));
      }
    },
  },
  watch: {
    isMenuVisible(nV) {
      if (nV) {
        const swatches = JSON.parse(localStorage.getItem('color-swatches') || '[]');
        this.localStorageSwatches = swatches;
      }
    },
  },
};
